import React from 'react'

export const NavExpandIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='32'
        height='32'
      >
        <rect width='32' height='32' fill='#D9D9D9' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M7.48603 26.6668C6.87225 26.6668 6.35981 26.4613 5.9487 26.0502C5.53759 25.6391 5.33203 25.1266 5.33203 24.5128V7.4875C5.33203 6.87372 5.53759 6.36127 5.9487 5.95016C6.35981 5.53905 6.87225 5.3335 7.48603 5.3335H24.5114C25.1251 5.3335 25.6376 5.53905 26.0487 5.95016C26.4598 6.36127 26.6654 6.87372 26.6654 7.4875V24.5128C26.6654 25.1266 26.4598 25.6391 26.0487 26.0502C25.6376 26.4613 25.1251 26.6668 24.5114 26.6668H7.48603ZM15.9987 25.3335H24.5114C24.7167 25.3335 24.9048 25.2481 25.0757 25.0772C25.2466 24.9063 25.332 24.7182 25.332 24.5128V7.4875C25.332 7.28216 25.2466 7.09405 25.0757 6.92316C24.9048 6.75227 24.7167 6.66683 24.5114 6.66683H15.9987V25.3335Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
